import React, { useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './RegistrationAgreement.scss';
import Steps from './Steps';
import ConfirmRegistration from './http/ConfirmRegistration';
import RegistrationContext from './context/RegistrationContext';

const RegistrationAgreement = () => {
  const { registrationData, cancelRegistration, guid } =
    useContext(RegistrationContext);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCancel = async () => {
    cancelRegistration();
    navigate('/cancel-registration');
  };

  const handleContinue = async () => {
    setIsSubmitting(true);

    const email = registrationData?.email || sessionStorage.getItem("email");

    if (!email || !guid) {
      console.error("Missing email or guid", { email, guid });
      setIsSubmitting(false);
      return;
    }
    try {
      await ConfirmRegistration(email, guid);
      navigate('/verify-registration');
    } catch (err) {
      console.error("ConfirmRegistration failed", err);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="finalize-registration-page page-container">
      <div className="page-title">
        <h1>LeapFrog Lab Registration</h1>
      </div>
      <Steps activeItem={3} />
      <div className="child-form form-group">
        <h2 className="page-subtitle">Participation Agreement</h2>
        <p>
          I understand the information I provide may be used in connection with
          product development and testing by LeapFrog Enterprises,
          Inc.("LeapFrog"), including to inform me of any future product
          testing, focus group, or other opportunities for my child and me to
          participate inLeapFrog Lab. I understand that I may request, in
          writing, to have access to all information about myself or my child
          and/or to have all information provided by me removed by LeapFrog
          Lab's participant database.
        </p>
        <p>
          Eligibility: I represent that neither I nor any member of my immediate
          family is an employee of, or otherwise related to, any toy
          manufacturer, distributor, or retailer, any company in the news media
          industry, including television, radio, print, and online news media
          companies, or any marketing or advertising company. I understand that
          LeapFrog does not provide participant transportation to or from its
          testing sites.
        </p>
        <p>I have read the statements above, and by clicking below:</p>
        <div className="registration-agreement-actions button-group">
          <button
            className="button primary"
            onClick={() => {
              handleContinue();
            }}
          >
            {isSubmitting ? 'Submitting...' : 'I agree'}
          </button>
          <button
            className="button cancel secondary"
            onClick={() => {
              handleCancel();
            }}
          >
            I do not agree
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationAgreement;
